import { createSlice } from '@reduxjs/toolkit';
import { get } from 'lodash';
import { geneAsyncAction } from 'services/actionConfigs';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { featureName, GetSupplierListParams, ISuppliersResponse } from './constants';

const createAsync = geneAsyncAction(featureName);

const async = {
  getSupplierList: createAsync<GetSupplierListParams, ISuppliersResponse>('getSupplierList'),
};

export type IsupplierReducerState = {
  isLoading: boolean;
  suppliersData: ISuppliersResponse;
};

type MyState = IsupplierReducerState;

const reducers = {
  uiInit: (state: MyState, {}: { payload: string }) => {
    state.isLoading = true;
  },
};
// @ts-ignore
const getCurrentState = (state: RootState): MyState => state['supplier']; // ex: state['booking']

const selector = <T = MyState>(key: keyof T, defaultValue?: any) =>
  useAppSelector((state) => get(getCurrentState(state), key, defaultValue));

const selectors = {
  isLoading: () => selector('isLoading') as MyState['isLoading'],
  suppliersData: () => selector('suppliersData') as MyState['suppliersData'],
};

const Slice = createSlice({
  name: featureName,
  initialState: {
    isLoading: false,
    suppliersData: {
      totalElements: 0,
      totalPages: 0,
      pageable: {
        sort: {
          sorted: false,
          empty: false,
          unsorted: true,
        },
        pageNumber: 0,
        pageSize: 0,
        offset: 0,
        paged: false,
        unpaged: true,
      },
      content: [],
    },
  } as MyState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(async.getSupplierList.fetch, (state) => {
        state.isLoading = true;
      })
      .addCase(async.getSupplierList.success, (state, { payload }) => {
        state.isLoading = false;
        state.suppliersData = payload;
      })
      .addCase(async.getSupplierList.fail, (state) => {
        state.isLoading = false;
      });
  },
});

const actions = {
  ...Slice.actions,
  async,
};
const reducer = Slice.reducer;

export { actions, reducer, selectors };
